import { isInNewCartExperiment } from './new-cart-exp-helper'

function useInNewCart(): boolean {
  return isInNewCartExperiment()
}

export default useInNewCart
